import CardRegisterNew from "features/user/components/cardRegister/CardRegisterNew";
import type { FC } from "react";

const SignupNew: FC = () => {
  return <CardRegisterNew confirmationButtonPath="/signup/confirm" />;
};

export default SignupNew;
